export var main_lbl_backToLogin = {
    key: 'reset_password::main_lbl_backToLogin',
    fallback: "Back to Login"
};
export var requestReset_btn_sendEmail = {
    key: 'reset_password::requestReset_btn_sendEmail',
    fallback: "Send Email"
};
export var requestReset_lbl_dropUsYourEmail = {
    key: 'reset_password::requestReset_lbl_dropUsYourEmail',
    fallback: "Drop us your email so we can help you recover"
};
export var requestReset_msgSuccess_checkInbox = {
    key: 'reset_password::requestReset_msgSuccess_checkInbox',
    fallback: "Please check your inbox"
};
export var requestReset_title_forgotPassword = {
    key: 'reset_password::requestReset_title_forgotPassword',
    fallback: "Forgot your password?"
};
export var requestReset_title_helpRegainAccess = {
    key: 'reset_password::requestReset_title_helpRegainAccess',
    fallback: "Let\u2019s help you regain access to PaymentsOS"
};
export var resetForm_btn_reset = {
    key: 'reset_password::resetForm_btn_reset',
    fallback: "Reset"
};
export var resetForm_msgSuccess_passwordChanged = {
    key: 'reset_password::resetForm_msgSuccess_passwordChanged',
    fallback: "Successfully changed password"
};
export var resetForm_title_resetPassword = {
    key: 'reset_password::resetForm_title_resetPassword',
    fallback: "Password reset"
};
